import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'lib-dynamic-page-general-field-styles',
  standalone: false,
  templateUrl: './dynamic-page-general-field-styles.component.html',
  styleUrl: './dynamic-page-general-field-styles.component.scss'
})
export class DynamicPageGeneralFieldStylesComponent {

  @Input() fontSize: Number;
  
  @Input() color: string;

  @Input() align: string;

  @Output() fontSizeChange = new EventEmitter<number>();
  @Output() colorChange = new EventEmitter<string>();
  @Output() alignChange = new EventEmitter<string>();

  onFontSizeChange(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    const numberValue = Number(value);
    this.fontSize = numberValue;
    this.fontSizeChange.emit(numberValue);
  }

  onColorChange(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.color = value;
    this.colorChange.emit(value);
  }

  onAlignChange(value: string) {
    this.align = value;
    this.alignChange.emit(value);
  }
}
